"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const FreePlanButton_1 = __importDefault(require("./FreePlanButton"));
const FreePlanCard = ({ onClick }) => (React.createElement("section", { className: "free-plan-card sui-p-4 sui-mx-2 sui-mb-4 d:sui-px-6 d:sui-mx-4 d:sui-mt-4" },
    React.createElement("h3", { className: "sui-font-size-8 sui-mb-1 sui-font-medium" }, "Or, go with the free plan"),
    React.createElement("p", { className: "sui-mb-2" }, "You'll miss out on top features like availability, training plans & drills, assignments, larger roster size and storage."),
    React.createElement(FreePlanButton_1.default, { onClick: onClick })));
exports.default = FreePlanCard;
